import React, { Fragment } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    makeStyles,
    IconButton,
    Grid,
    Button,
    TextField,
    colors,
} from "@material-ui/core";
import RestInfo from "./RestInfo";
import { useStylesDPM } from "../../../../../St/comps/UseStyle";

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(1),
        position: "absolute",
        top: theme.spacing(1),
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },
    dialogTitle: {
        textAlign: "center",
    },
    dialogContent: {
        textAlign: "center",
    },
    dialogAction: {
        justifyContent: "center",
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            cursor: "default",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "8rem",
        },
    },
}));

export default function RestInfoDialog(props) {
    const {infoData,setInfoData, res_id, branch, fromInv, proc_id} = props;
    const classes = useStyles();
    const clasPM = useStylesDPM();

    return (
        <Dialog open={infoData.open} 
        classes={{ paper: classes.dialog }}
        lg={{ direction: "rtl", minHeight: 600 }}
        aria-labelledby="form-dialog-title"
        >
            <DialogContent className={classes.dialogContent}>
                <RestInfo
                    {...{
                        res_id, branch, fromInv, proc_id,
                    }}
                />
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button onClick={() => setInfoData({ ...infoData, open: false })}>إغلاق </Button>
            </DialogActions>
        </Dialog>
    );
}


